import SkillsAssessmentIcon from 'img/icons/offering_icons/skills_assessment.svg';
import {
  BodyRowType,
  HeaderIconConfig,
  IconType,
  OfferingTypeConfig,
} from '../utils/types';

const skillsAssessmentIconConfig: HeaderIconConfig = {
  backgroundColor: '#8A5A7B',
  iconTitle: 'Skills Assessment',
  src: SkillsAssessmentIcon,
};

const skillsAssessmentConfig: OfferingTypeConfig = {
  actionButtons: ({ skillsAssessmentId, routerStore }) => {
    const routeName = 'skills-assessments';
    const routeParams = { id: skillsAssessmentId };

    return {
      actionButtonA: {
        href: routerStore.router.buildUrl(routeName, routeParams),
        buttonLabel: 'View',
        icon: IconType.Arrow,
        onClick: () =>
          routerStore.navigate('skills-assessments', {
            id: skillsAssessmentId,
          }),
      },
    };
  },
  bodyRowsLayout: () => [BodyRowType.Custom],
  headerConfig: ({ t }) => ({
    iconB: skillsAssessmentIconConfig,
    title: t('Skills Assessment'),
  }),
};

export default skillsAssessmentConfig;
